import { render, staticRenderFns } from "./AppliedStartups.vue?vue&type=template&id=220b9a38&scoped=true&"
import script from "./AppliedStartups.vue?vue&type=script&setup=true&lang=js&"
export * from "./AppliedStartups.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220b9a38",
  null
  
)

export default component.exports